import { useEffect, useRef } from 'react';

import { useTopBannerHeight } from '../../TopBannerHeightProvider';

export const useTopBannerRef = () => {
  const { setTopBannerHeight } = useTopBannerHeight();
  const resizeObserver = useRef<ResizeObserver | null>();

  const refCallback = (element: HTMLDivElement) => {
    if (element) {
      setTopBannerHeight(element.clientHeight);

      resizeObserver.current = new ResizeObserver(() => {
        setTopBannerHeight(element.clientHeight);
      });

      resizeObserver.current.observe(element);
    } else {
      resizeObserver.current?.disconnect();
      resizeObserver.current = null;
    }
  };

  useEffect(
    () => () => {
      resizeObserver.current?.disconnect();
      setTopBannerHeight(0);
    },
    // no dependencies are needed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return refCallback;
};
